import { DatePicker } from "antd";
import { Calendar, PlusCircle, Edit, X, Check } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Trash2 from "feather-icons-react/build/IconComponents/Trash2";
import { useGetAvailableInventoryQuery, useGetProductListQuery } from "../../redux/api/productApi";
import { useGetAllSupplierQuery } from "../../redux/api/userApi";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { 
    useCreatePurchaseOrderMutation,
    useGetTodayPurchaseOrderQuery, 
    useDeletePurchaseOrderMutation, 
    useUpdatePurchaseOrderMutation, 
    useGetPurchaseOrderByIdQuery 
  } from "../../redux/api/OrderApi";
import Table from "../../pagination/datatable";
import SupplierModal from "../peoples/supplierModal";
import toast from "react-hot-toast";

const productSchema = Yup.object().shape({
  product: Yup.object().required('Product is required'),
  unit: Yup.string(),
  quantity: Yup.number()
    .typeError('Quantity must be a number')
    .required('Quantity is required')
    .positive('Quantity must be greater than 0'),
  purchaseRate: Yup.number()
    .typeError('Rate must be a number')
    .required('Rate is required')
    .positive('Rate must be greater than 0'),
  note: Yup.string(),
  supplier: Yup.object().required('Supplier is required'),
});

const PurchaseOrderSchema = Yup.object().shape({
  purchaseDate: Yup.date().required('Date is required'),
});

const AddPurchases = ({productResponse, supplierResponse}) => { 
  const [PurchaseOrderId, setPurchaseOrderId] = useState(null);
  const [updatePurchasesOrder] = useUpdatePurchaseOrderMutation();
const [deletePurchaseOrderOrder] = useDeletePurchaseOrderMutation();

// const [editingPurchasesOrder, seteditingPurchasesOrder] = useState(null);
// const { data: PurchaseOrderOrders } = useGetPurchaseOrdersQuery();
const {data: todayPurchaseOrder, isLoading:isTodayPurchaseOrderLoading , refetch: refetchTodayPurchaseOrders} = useGetTodayPurchaseOrderQuery();
const {data: inventoryRemaining, refetch: refetchInventoryRenaining} = useGetAvailableInventoryQuery();
const { data: singlePurchasesOrder } = useGetPurchaseOrderByIdQuery(PurchaseOrderId, {
  skip: !PurchaseOrderId  // <-- don't run unless ID is set
});
const [editProduct, setEditProduct] = useState(null);
const [editingPurchasesOrder, setEditingPurchasesOrder] = useState(null);
console.log("todayPurchaseOrder",todayPurchaseOrder);

const [formData, setFormData] = useState(null);

// Store current form data before redirecting
const navigate = useNavigate(); 
const [showSupplierRedirect, setShowSupplierRedirect] = useState(false);
const handleRouteClick = () => {
  setFormData(formik.values);
  setShowSupplierRedirect(true);
  document.querySelector('#add-units [data-bs-dismiss="modal"]')?.click();
};

// This effect runs after the purchases modal closes
useEffect(() => {
  if (showSupplierRedirect && formData) {
    navigate('/supplier-list', {
      state: { 
        returnTo: '/purchase-list',
        purchaseFormData: formData 
      }
    });
  }
}, [showSupplierRedirect, formData, navigate]);
useEffect(() => {
  if (singlePurchasesOrder) {
    formik.setValues({
      ...formik.values,
      purchaseDate: singlePurchasesOrder.purchaseDate,
      products: singlePurchasesOrder.products.map(p => ({
        ...p,
        product: productlist.find(pr => pr.value === p.product),
        supplier: suppliersList.find(s => s.value === p.supplier),
        purchaseRate: p.rate,
      }))
    });
  }
}, [singlePurchasesOrder]);


  console.log("supplierResponse", supplierResponse);
 
  const [createPurchasesOrder, { isLoading: isCreating }] = useCreatePurchaseOrderMutation();
  const productlist = productResponse?.data?.map(item => ({
    value: item?._id,
    label: item?.productName,
    unit: item?.unit,
    purchaseRate: item?.purchaseRate 
  }));

  const suppliersList = supplierResponse?.map(item => ({
    value: item?._id,
    label: item?.supplierName
  }));
 console.log("supplierslist", suppliersList );
  const processedProducts = todayPurchaseOrder?.map(order => ({
    ...order,
    PurchaseOrderId: order._id // Store the PurchaseOrder order ID with each product
  })) || [];
  const formik = useFormik({
    initialValues: {
      purchaseDate: new Date(),
      currentProduct: {
        supplier: null,
        product: null,
        quantity: 0,
        unit: '',
        purchaseRate: 0,
        note: ''
      },
      products: [],
      editIndex: null
    },
    validationSchema: PurchaseOrderSchema,
    onSubmit: async(values) => {
      try {
        // Check if there's at least one product
        if (values.products.length === 0) {
          toast.success("Please add at least one product");
          return;
        }
        console.error("product.supplier.value, ", product.supplier.value, );
        const purchasesData = {
            purchaseDate: values.purchaseDate,
              product: product.product.value,
              supplier: product.supplier.value,  
              quantity: product.quantity,
              unit: product.unit,
              purchaseRate: product.purchaseRate, 
              note: product.note
        
        };
  
      
        const response = await createPurchasesOrder(purchasesData).unwrap();
        setPurchaseOrderId(response?._id);
        toast.success("PurchaseOrder order saved successfully!");
        // navigate('/PurchaseOrders');
      } catch (error) {
        toast.error(`Failed to create PurchaseOrder order: ${error?.data?.message || error.message}`);
      }
    },
  });

  const handleProductSelect = (option) => {
    handleCurrentProductChange('product', option);
    // Auto-populate unit and rate from selected product
    if (option) {
      handleCurrentProductChange('unit', option.unit?.unitName || '');  // Access unitName properly
      handleCurrentProductChange('purchaseRate', option.purchaseRate || '');
    }
  };

  const handleAddProduct = async () => {
    try {
      await productSchema.validate(formik.values.currentProduct, { abortEarly: false });
      // console.log("formik.values.currentProduct", formik.values.currentProduct);
      // Prepare the single product data for API
      const productData = {
        purchaseDate: formik.values.purchaseDate,
        productId: formik.values.currentProduct.product.value,
        supplierId: formik.values.currentProduct.supplier.value,
        quantity: formik.values.currentProduct.quantity,
        unit: formik.values.currentProduct.unit,
        purchaseRate: formik.values.currentProduct.purchaseRate,
        note: formik.values.currentProduct.note || ''
      };
      // console.error("productData" , productData);
  
      // Call API to create PurchaseOrder order immediately
      const response = await createPurchasesOrder(productData).unwrap();
  
      toast.success(`PurchaseOrder order for ${formik.values.currentProduct.product.label} created successfully!`);
      refetchInventoryRenaining(); // Refresh inventory data
      // Optionally add to products array to show in UI history
      formik.setValues({
        ...formik.values,
        products: [...formik.values.products, formik.values.currentProduct],
        currentProduct: {
          supplier: null,
          product: null,
          quantity: 0,
          unit: '',
          purchaseRate: '',
          note: ''
        },
        editIndex: null
      });
    } catch (errors) {
      if (errors.inner) {
        // Convert yup errors to Formik-compatible format
        const validationErrors = {};
        errors.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        
        // Set errors for the nested currentProduct fields
        formik.setErrors({
          currentProduct: validationErrors
        });
        
        // Mark fields as touched so errors show up
        const touchedFields = {};
        Object.keys(validationErrors).forEach(key => {
          touchedFields[key] = true;
        });
        formik.setFieldTouched('currentProduct', {
          ...formik.touched.currentProduct,
          ...touchedFields
        }, false);
      } else {
        // Handle API errors
        toast.error(`Failed to add product: ${errors?.data?.message || errors.message || errors}`);
      }
    }
  };
  const handleUpdateProduct = async () => {
    if (!editingPurchasesOrder) return;
  
    try {
      // Validate current product
      await productSchema.validate(formik.values.currentProduct);
     const PurchaseOrderId = editingPurchasesOrder
      const updateData = {
        // The PurchaseOrder order ID to update
        purchaseDate: formik.values.purchaseDate,
        productId: formik.values.currentProduct.product.value,
        supplierId: formik.values.currentProduct.supplier.value,
        quantity: formik.values.currentProduct.quantity,
        unit: formik.values.currentProduct.unit,
        purchaseRate: formik.values.currentProduct.purchaseRate,
        note: formik.values.currentProduct.note || ''
      };
      console.log("Sending update payload:", updateData); 
      // Call update mutation
      const response = await updatePurchasesOrder({ _id: editingPurchasesOrder, ...updateData }).unwrap();
      
      // Refresh data
      refetchTodayPurchaseOrders();
      refetchInventoryRenaining();
      // Reset form and editing state
      setEditingPurchasesOrder(null);
      formik.resetForm();
      
      toast.success("PurchaseOrder order updated successfully!");
    } catch (error) {
      console.error("Update error:", error);
      toast.error(`Failed to update: ${error?.data?.message || error.message}`);
    }
  };
  
  
  const handleRemoveProduct = async (id) => {
      
    if (id) {
      try {
        await deletePurchaseOrderOrder(id).unwrap();
        console.log('Deleted PurchaseOrder order:', id);
      } catch (error) {
        console.error('Failed to delete:', error);
        toast.error('Error deleting product');
        return;
      }
    }
    toast.success('Product deleted successfully');
  };
  
  const handleEditProduct = (product) => {
    setEditingPurchasesOrder(product._id); // Store the PurchaseOrder order ID
    
    // Find the product and supplier objects
    const productObj = productlist?.find(p => p.value === product.product?._id) || {
      value: product.product?._id,
      label: product.product?.productName
    };
    
    const supplierObj = suppliersList?.find(s => s.value === product.supplier?._id) || {
      value: product.supplier?._id,
      label: product.supplier?.supplierName
    };
  
    formik.setValues({
      ...formik.values,
      purchaseDate: new Date(product.purchaseDate),
      currentProduct: {
        supplier: supplierObj,
        product: productObj,
        quantity: product.quantity,
        unit: product.unit,
        purchaseRate: product.rate || product.purchaseRate,
        note: product.note || ''
      }
    });
  };


  

  const handleCancelEdit = () => {
    formik.setValues({
      ...formik.values,
      currentProduct: {
        supplier: null,
        product: null,
        quantity: 0,
        unit: '',
        purchaseRate: '',
        note: ''
      },
      editIndex: null
    });
    formik.setErrors({ currentProduct: {} });
  };

  const handleCurrentProductChange = (field, value) => {
    console.log("handleCurrentProductChange", field, value);
    // Only convert to number for quantity and purchaseRate
    const processedValue = (field === 'quantity' || field === 'purchaseRate') 
      ? (value === '' ? '' : Number(value))
      : value;
    
    formik.setFieldValue(`currentProduct.${field}`, processedValue);
    
    // Clear error when field changes
    if (formik.errors.currentProduct?.[field]) {
      const newErrors = { ...formik.errors.currentProduct };
      delete newErrors[field];
      formik.setErrors({ 
        ...formik.errors,
        currentProduct: Object.keys(newErrors).length ? newErrors : undefined
      });
    }
  };

  const getCurrentProductError = (field) => {
    return formik.touched.currentProduct?.[field] && formik.errors.currentProduct?.[field];
  };
console.log("formik.values.currentProduct.supplier.supplierId", formik?.values?.currentProduct);
 


const purchaseOrderColumns = [
  {
    title: "S No.",
    dataIndex: "serial",
    key: "serial",
    render: (text, record, index) => index + 1,
  },
  {
    title: "Supplier Name",
    dataIndex: ["supplier", "supplierName"], // or supplier.label if fallback needed
    key: "supplierName",
    render: (text, record) => record?.supplier?.supplierName || record?.supplier?.label || "-",
  },
  {
    title: "Product Name",
    dataIndex: ["product", "productName"], // or product.label if fallback needed
    key: "productName",
    render: (text, record) => record.product?.productName || record.product?.label || "-",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Unit",
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: "Purchase Rate",
    dataIndex: "purchaseRate",
    key: "purchaseRate",
    render: (text, record) => record.purchaseRate || record.rate || "-",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
    render: (text) => text || "-",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => (
      (record.quantity * (record.purchaseRate || record.rate || 0)).toFixed(2)
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <>
        <button
          type="button"
          className="btn btn-sm btn-info me-2"
          onClick={() => handleEditProduct(record)}
          disabled={editProduct !== null}
        >
          <Edit size={14} />
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() => handleRemoveProduct(record._id)}
          disabled={formik.values.editIndex !== null}
        >
          <Trash2 size={14} />
        </button>
      </>
    ),
  },
];

const inventoryAvailable = [
  {
    title: "S No.",
    dataIndex: "serial",
    key: "serial",
    render: (text, record, index) => index + 1,
  },
  {
    title: "Product Id",
    dataIndex: "productId", 
   key: "productId"
    // render: (text, record) => record?.Name || record?.supplier?.label || "-",
  },
  {
    title: "Product Name",
    dataIndex: "productName", // or product.label if fallback needed
    key: "productName"
  },
  {
    title: "Available Quantity",
    dataIndex: "quantity", // or product.label if fallback needed
    key: "quantity"
  }
]

console.log("inverasdklfjsdlk;f",inventoryRemaining);

return (
    <div>
      {/* Add PurchaseOrder */}
       <div className="modal fade" id="add-units">
        <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
          
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  
                  <div className="page-title">
                    <h4>Add Purchases</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                 <div className="table-responsive">
                {isTodayPurchaseOrderLoading ? (
                  <p>Loading...</p>
                ) : (
                  <Table
                
              columns={inventoryAvailable}
              dataSource={Array.isArray(inventoryRemaining) ? inventoryRemaining : []}
              rowKey={(record, index) => record._id || index}
              // pagination={{ pageSize: 3 }}
              default_page_size={3}
            />

                )}
          </div>
                <div className="modal-body custom-modal-body">
                <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>Purchase Date</label>
            <div className="input-groupicon calender-input">
              <Calendar className="info-img" />
              <span style={{ marginLeft: '10px' }}>
                          {new Date().toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
               </span>
            </div>
            {formik.touched.purchaseDate && formik.errors.purchaseDate && (
              <div className="text-danger">{formik.errors.purchaseDate}</div>
            )}
          </div>
        </div>
      </div>

      {/* Single Product Form */}
      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div className="input-blocks add-product">
            <label>Supplier Name</label>
            <div className="row">
              <div className="col-lg-10 col-sm-10 col-10">
                <Select
                  name="supplier"
                  options={suppliersList}
                  classNamePrefix="react-select"
                  placeholder="Choose"
                  value={formik.values.currentProduct.supplier}
                  onChange={(option) => handleCurrentProductChange('supplier', option)}
                  onBlur={() => formik.setFieldTouched('currentProduct.supplier', true)}
                />
                {getCurrentProductError('supplier') && (
                  <div className="text-danger">{getCurrentProductError('supplier')}</div>
                )}
              </div>
              <div className="col-lg-2 col-sm-2 col-2 ps-0">
                <div className="add-icon tab"  onClick={handleRouteClick}>
                  <Link to="#">
                    <PlusCircle className="feather-plus-circles" />
                  </Link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>Product Name</label>
            <Select
              options={productlist}
              classNamePrefix="react-select"
              placeholder="Choose"
              value={formik.values.currentProduct.product}
              onChange={handleProductSelect}
              onBlur={() => formik.setFieldTouched('currentProduct.product', true)}
            />
            {getCurrentProductError('product') && (
              <div className="text-danger">{getCurrentProductError('product')}</div>
            )}
          </div>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>Quantity</label>
            <input
              type="number"
              className="form-control"
              name="quantity"
              value={formik.values.currentProduct.quantity}
              onChange={(e) => handleCurrentProductChange('quantity', e.target.value)}
              onBlur={() => formik.setFieldTouched('currentProduct.quantity', true)}
            />
            {getCurrentProductError('quantity') && (
              <div className="text-danger">{getCurrentProductError('quantity')}</div>
            )}
          </div>
        </div>
          <div className="col-lg-2 col-md-6 col-sm-12">
            <div className="input-blocks">
              <label>Unit</label>
              <input
                type="text"
                className="form-control"
                name="unit"
                value={formik.values.currentProduct.unit || ''}
                onChange={(e) => handleCurrentProductChange('unit', e.target.value)}
                onBlur={() => formik.setFieldTouched('currentProduct.unit', true)}
                readOnly  // Make it read-only since it's populated from product selection
              />
              {getCurrentProductError('unit') && (
                <div className="text-danger">{getCurrentProductError('unit')}</div>
              )}
            </div>
          </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-2 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>Purchase Rate</label>
            <input
              type="number"
              className="form-control"
              name="purchaseRate"
              value={formik.values.currentProduct.purchaseRate}
              onChange={(e) => handleCurrentProductChange('purchaseRate', e.target.value)}
              onBlur={() => formik.setFieldTouched('currentProduct.purchaseRate', true)}
            />
            {getCurrentProductError('purchaseRate') && (
              <div className="text-danger">{getCurrentProductError('purchaseRate')}</div>
            )}
          </div>
        </div>
        
        <div className="col-lg-2 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>Note</label>
            <input
              type="text"
              className="form-control"
              name="note"
              value={formik.values.currentProduct.note}
              onChange={(e) => handleCurrentProductChange('note', e.target.value)}
              onBlur={() => formik.setFieldTouched('currentProduct.note', true)}
            />
            {getCurrentProductError('note') && (
              <div className="text-danger">{getCurrentProductError('note')}</div>
            )}
          </div>
        </div>
        
        <div className="col-lg-2 col-md-6 col-sm-12 d-flex align-items-end">
  <div className="input-blocks w-100 d-flex justify-content-end">
    {editingPurchasesOrder ? (
      <>
        <button 
          type="button"
          className="btn btn-success me-2"
          onClick={handleUpdateProduct}
        >
          Update
        </button>
        <button 
          type="button"
          className="btn btn-secondary"
          onClick={() => {
            setEditingPurchasesOrder(null);
            formik.resetForm();
          }}
        >
          Clear
        </button>
      </>
    ) : (
      <button 
        type="button"
        className="btn btn-primary"
        onClick={handleAddProduct}
      >
        Add Product
      </button>
    )}
  </div>
</div>
      </div>

      {/* Products Table */}
      <div className="row mt-4">
        <div className="col-lg-12">
          <div className="modal-body-table">
          <div className="table-responsive">
                {isTodayPurchaseOrderLoading ? (
                  <p>Loading...</p>
                ) : (
                  <Table
                
              columns={purchaseOrderColumns}
              dataSource={Array.isArray(todayPurchaseOrder) ? todayPurchaseOrder : []}
              rowKey={(record, index) => record._id || index}
              // pagination={{ pageSize: 3 }}
              default_page_size={3}
            />

                )}
          </div>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="modal-footer-btn">
            <button
              type="button"
              className="btn btn-cancel me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add PurchaseOrder */}
      
      <SupplierModal 
      onSuccess={() => {
          toast.success("Supplier created Successfully!");
         // Refresh purchase orders after adding supplier
        // Refresh inventory data
    
      }}
      />
    </div>
  );
};

export default AddPurchases;
